
import { Component, ActionButtonConfig, FormModalMixins ,appConst} from "@/lib";
import Customer from "@/store/modules/system/customer/entity";
@Component
export default class CreateCustomer extends FormModalMixins {
  model = new Customer();
  async created() {
    Object.assign(this.config, { modelTitleL: "Action.Add", labelWidth: 200, okAction: "system/customer/create" });
     await this.$store.dispatch("system/customer/getBusinessGroupList");
  }
  get customerBusinessGroupList(){
    return this.$store.state.system.customer.businessGroupList;

  }
     get paymentList() {
    return this.getCodeListByCategory(
      appConst.codeCategory.payment)
  }
  
  formValidateRule(data){
     const messageError = "超过系统支持业务组上限";
    if(data==undefined){
      return;
    }
    else{
     let q=data.toString();
     
     return[{validator: (rule:any, value:any, callback:any) => {
     if(q.length>10){
       callback(messageError);
     }
     else{
       callback();
     }
     }}];
    }
  }
  
    
}
